import { HttpErrorIgnore, HttpErrorUpsert, HttpImportResult, HttpUpsert200 } from '../../../../global';
import apiSvc, { BinaryFileType } from '../../../core/services/apiSvc';
import validSvc from '../../../core/validSvc';

// read
export const GET_LIST = 'admin/payor/list';
const GET_DETAIL = 'admin/payor/get';
const GET_EXCEL = 'admin/payor/excel';

// write
const CREATE_PAYOR = 'admin/payor/add';
const UPDATE_PAYOR = 'admin/payor/save';
const UPDATE_PAYOR_STATUS_ACTIVE = 'admin/payor/status/active';
const UPDATE_PAYOR_STATUS_INACTIVE = 'admin/payor/status/inactive';
const POST_IMPORT = 'admin/payor/import';

export async function getDetail(id: string): Promise<object> {
    // params
    if (!validSvc.isText(id)) {
        throw new Error('payorRepo.getDetail, id is required');
    }

    return apiSvc.getEntity(GET_DETAIL, {
        Params: {
            Id: id,
        },
    });
}

export async function upsert(action: string, m: object): Promise<HttpUpsert200 | HttpErrorUpsert> {
    switch (action) {
        case 'CREATE':
            return apiSvc.postModel(CREATE_PAYOR, payorModelAPI(m));
        case 'UPDATE':
            return apiSvc.postModel(UPDATE_PAYOR, payorModelAPI(m));
        default:
            throw new Error('adminPayorRepo.postPayor, unknown: ' + action);
    }
}

function payorModelAPI(m): object {
    return {
        Entity: {
            Id: m.Id,
            ObjectState: m.Status.val,
            MedType: m.MedType.val,
            State: m.State.val,
            BIN: m.BIN.val,
            PCN: m.PCN.val,
            GroupNumber: m.GroupNumber.val,
            Name: m.Name.val,
        },
    };
}

export async function updateStatus(id: string, action: string): Promise<HttpUpsert200 | HttpErrorUpsert> {
    // params
    if (!validSvc.isText(id)) {
        throw new Error('payorRepo.updateStatus, id required');
    }
    console.log('payorRepo update status: ' + action + ' ' + id);

    const request = {
        Params: {
            Id: id,
        },
    };

    switch (action) {
        case 'ACTIVE':
            return apiSvc.postModel(UPDATE_PAYOR_STATUS_ACTIVE, request, false, false);
        case 'INACTIVE':
            return apiSvc.postModel(UPDATE_PAYOR_STATUS_INACTIVE, request, false, false);
        default:
            throw new Error('adminPayorRepo.updateStatus, unknown: ' + action);
    }
}

export async function getExcel(fileName: string): Promise<HttpErrorIgnore | undefined> {
    // params
    if (!validSvc.isText(fileName)) {
        throw new Error('payorRepo.getExcel, filename is required');
    }
    return apiSvc.postGetBinary(GET_EXCEL, {}, fileName, BinaryFileType.Excel);
}

export async function postImport(importFile: Blob): Promise<HttpImportResult | HttpErrorUpsert> {
    try {
        if (!importFile) {
            throw new Error('payorRepo.postImport, file is required');
        }

        const r = await apiSvc.postFile(POST_IMPORT, {}, importFile);
        return r as HttpImportResult;
    } catch (err: any) {
        return err as HttpErrorUpsert;
    }
}

export const payorRepo = {
    getDetail,
    upsert,
    updateStatus,
    getExcel,
    postImport,
};
export default payorRepo;
